<template>
  <div id="principal">
      <div class="top-header" style="height: 357px;width: 100%;max-height: 415px;">
        <img src="/sandboxfront/mapatributario/logo.svg" alt="" style="margin-top: 90px;    width: 390px;">
      </div>
      <div class="meio" style="top: -90px;text-align:justify;" >
        <img src="https://www.lefisc.com.br/sandboxfront/mapatributario/icon.svg" alt="" style="margin-right: 70px;"> 
        <div>
          <p style="color:#6A6A6A;font-size: 20px;font-weight: 400;margin:0px;">O <span style="font-weight:600">Mapa Tributário da LEFISC</span> fornece uma base de consulta tributária completa. Ela permite a pesquisa da tributação de um produto atráves de sua NCM.
            </p>
            <div style="margin:40px 0px;">
              <a href="https://youtu.be/skqphwaThEY" target="_blank"><img src="https://www.lefisc.com.br/sandboxfront/mapatributario/tutorial.svg" alt="" style="margin-right:50px;cursor:pointer"></a>
              
              <a href="https://www.lefisc.com.br/mapatributario/teste" target="_blank"> <img src="https://www.lefisc.com.br/sandboxfront/mapatributario/demostracao.svg" alt="" style="cursor:pointer"></a>
            </div>
              <button type="primary" style="border-radius: 10px;    margin: 0px;    font-size: 18px;    height: 40px;    width: 150px;    color: rgb(255, 255, 255) !important;    font-weight: 600;background: #4A154B;" @click="$router.push({name:'ano', params:{ano:'calculo'}})" v-if="isButton">Acessar</button>
            </div>         
        </div>
       
        <div>
 
            
       
      </div>   
      
  </div>
</template>

<script>
export default {

  data(){
    return{
      isButton:true
    }
  },
  mounted(){   

    let obj = JSON.parse(window.localStorage.getItem('objCli'))
        if(obj.login != 'lefisc'){
           // this.isButton  = true
        }else{
         // window.location = 'https://www.lefisc.com.br/mapatributario/teste/estado'
          //this.isButton = false
        }
  }
}
</script>

<style>
button span{
  color:#fff !important;
}
button{
  cursor: pointer;
}
#principal{
  border-top-left-radius: 5px;
    padding-bottom: 20px;
    border-top-right-radius: 5px;
    background: #EDE4ED  !important;    
    margin: 0 auto;
  
}

</style>